"use strict";

require("core-js/modules/es.array.iterator");

var curry = require("./curry.js");

var delay = require("./delay.js");

module.exports = curry(function debounce(f, time) {
  let i = 0;
  return function _debounce(...args) {
    return delay(time, ++i).then(id => id === i && f(...args));
  };
});